import React, { useMemo, useEffect, useRef } from "react";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import "./technologies_carousel.css";

const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
};

const ADVANCE_INTERVAL_MS = 4000;

const TechnologiesCarousel = ({ images, sliderConfig, animation }) => {
    const shuffledImages1 = useMemo(() => shuffleArray(images), [images]);
    const shuffledImages2 = useMemo(() => shuffleArray(images), [images]);
    const animationRef = useRef(animation);
    const slidersRef = useRef({ instanceRef1: null, instanceRef2: null });

    animationRef.current = animation;

    const [sliderRef1, instanceRef1] = useKeenSlider({
        ...sliderConfig,
        created(s) {
            s.moveToIdx(5, true, animationRef.current);
        },
    });

    const [sliderRef2, instanceRef2] = useKeenSlider({
        ...sliderConfig,
        rtl: true,
        created(s) {
            s.moveToIdx(5, true, animationRef.current);
        },
    });

    slidersRef.current.instanceRef1 = instanceRef1;
    slidersRef.current.instanceRef2 = instanceRef2;

    useEffect(() => {
        const runAdvance = () => {
            const { instanceRef1: ref1, instanceRef2: ref2 } = slidersRef.current;
            const anim = animationRef.current;
            [ref1, ref2].forEach((instanceRef) => {
                const instance = instanceRef?.current;
                if (instance) {
                    const abs = instance.track.details.abs;
                    instance.moveToIdx(abs + 5, true, anim);
                }
            });
        };

        const timeoutId = setTimeout(runAdvance, 0);
        const intervalId = setInterval(runAdvance, ADVANCE_INTERVAL_MS);

        return () => {
            clearTimeout(timeoutId);
            clearInterval(intervalId);
        };
    }, []);

    return (
        <div className="technologies_carousel_wrap">
            <div className="technologies_carousel_container keen-slider" ref={sliderRef1}>
                {shuffledImages1.map((image, index) => (
                    <div key={`tech1-${index}`} className="keen-slider__slide technologies_slide">
                        <div className="technologies_slide_inner">
                            <img src={image} alt={`Tecnologia ${index + 1}`} />
                        </div>
                    </div>
                ))}
            </div>
            <div className="technologies_carousel_container keen-slider" ref={sliderRef2}>
                {shuffledImages2.map((image, index) => (
                    <div key={`tech2-${index}`} className="keen-slider__slide technologies_slide">
                        <div className="technologies_slide_inner">
                            <img src={image} alt={`Tecnologia ${index + 1}`} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TechnologiesCarousel;
